import React, { useState, useEffect, useReducer, useContext } from "react";
import { toast } from "react-toastify";

import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import PeopleIcon from "@material-ui/icons/People";
import DownloadIcon from "@material-ui/icons/GetApp";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactListDialog from "../../components/ContactListDialog";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import { Grid, Box, Chip, Divider } from "@material-ui/core";
import AddIcon from '@mui/icons-material/Add';
import ListAltIcon from "@material-ui/icons/ListAlt";

import planilhaExemplo from "../../assets/planilha.xlsx";
import { AuthContext } from "../../context/Auth/AuthContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTLISTS") {
    const contactLists = action.payload;
    const newContactLists = [];

    contactLists.forEach((contactList) => {
      const contactListIndex = state.findIndex((u) => u.id === contactList.id);
      if (contactListIndex !== -1) {
        state[contactListIndex] = contactList;
      } else {
        newContactLists.push(contactList);
      }
    });

    return [...state, ...newContactLists];
  }

  if (action.type === "UPDATE_CONTACTLIST") {
    const contactList = action.payload;
    const contactListIndex = state.findIndex((u) => u.id === contactList.id);

    if (contactListIndex !== -1) {
      state[contactListIndex] = contactList;
      return [...state];
    } else {
      return [contactList, ...state];
    }
  }

  if (action.type === "DELETE_CONTACTLIST") {
    const contactListId = action.payload;
    const contactListIndex = state.findIndex((u) => u.id === contactListId);
    if (contactListIndex !== -1) {
      state.splice(contactListIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(2),
    overflowY: "scroll",
    backgroundColor: theme.palette.background.default,
    border: "none",
    ...theme.scrollbarStyles,
  },

  headerContainer: {
    background: "linear-gradient(90deg, #6517ab 0%, #8e44ad 100%)",
    padding: theme.spacing(3),
    borderRadius: "0 0 20px 20px",
    color: "white",
    marginBottom: theme.spacing(3),
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
  },
  title: {
    color: "white",
    fontWeight: "bold",
  },
  searchPaper: {
    padding: "4px 16px",
    display: "flex",
    alignItems: "center",
    borderRadius: "15px",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    "& .MuiInputBase-root": {
      color: "white",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "rgba(255, 255, 255, 0.7)",
      opacity: 1,
    },
  },
  addButton: {
    background: theme.palette.background.paper,
    color: "#6517ab",
    borderRadius: "15px",
    padding: "10px 20px",
    fontWeight: "600",
    textTransform: "none",
    "&:hover": {
      background: theme.palette.type === "light" ? "#f0f0f0" : "rgba(255, 255, 255, 0.1)",
    },
  },

  listCard: {
    borderRadius: "20px",
    transition: "all 0.3s ease",
    border: theme.palette.type === "dark" ? "1px solid rgba(255, 255, 255, 0.12)" : "none",
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    "& .MuiTypography-root": {
        color: theme.palette.text.primary
    },
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: theme.palette.type === "light" ? "0 10px 25px rgba(0,0,0,0.1)" : "0 8px 20px rgba(0,0,0,0.4)",
    },
  },

  cardContent: {
    padding: theme.spacing(3),
  },
  countChip: {
    borderRadius: "10px",
    fontWeight: "600",
    backgroundColor: theme.palette.type === "light" ? "#f3e5f5" : "rgba(101, 23, 171, 0.4)",
    color: theme.palette.type === "light" ? "#6517ab" : "#d1c4e9",
  },

  iconButton: {
    borderRadius: "12px",
    margin: theme.spacing(0, 0.5),
    transition: "all 0.2s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },

  // Novos estilos para os botões de ação para respeitar o tema
  downloadBtn: {
    backgroundColor: theme.palette.type === "light" ? "#e8f5e9" : "rgba(46, 125, 50, 0.15)",
    color: theme.palette.type === "light" ? "#2e7d32" : "#81c784",
    "&:hover": {
      backgroundColor: theme.palette.type === "light" ? "#c8e6c9" : "rgba(46, 125, 50, 0.3)",
    }
  },
  viewBtn: {
    backgroundColor: theme.palette.type === "light" ? "#e3f2fd" : "rgba(25, 118, 210, 0.15)",
    color: theme.palette.type === "light" ? "#1976d2" : "#64b5f6",
    "&:hover": {
      backgroundColor: theme.palette.type === "light" ? "#bbdefb" : "rgba(25, 118, 210, 0.3)",
    }
  },
  editBtn: {
    backgroundColor: theme.palette.type === "light" ? "#f3e5f5" : "rgba(101, 23, 171, 0.15)",
    color: theme.palette.type === "light" ? "#6517ab" : "#b39ddb",
    "&:hover": {
      backgroundColor: theme.palette.type === "light" ? "#e1bee7" : "rgba(101, 23, 171, 0.3)",
    }
  },
  deleteBtn: {
    backgroundColor: theme.palette.type === "light" ? "#ffebee" : "rgba(211, 47, 47, 0.15)",
    color: theme.palette.type === "light" ? "#d32f2f" : "#e57373",
    "&:hover": {
      backgroundColor: theme.palette.type === "light" ? "#ffcdd2" : "rgba(211, 47, 47, 0.3)",
    }
  },
  
  divider: {
    margin: "16px 0",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.08)"
  }
}));

const ContactLists = () => {
  const classes = useStyles();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedContactList, setSelectedContactList] = useState(null);
  const [deletingContactList, setDeletingContactList] = useState(null);
  const [contactListModalOpen, setContactListModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [contactLists, dispatch] = useReducer(reducer, []);
  const { user, socket } = useContext(AuthContext);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchContactLists();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber]);

  const fetchContactLists = async () => {
    try {
      const { data } = await api.get("/contact-lists/", {
        params: { searchParam, pageNumber },
      });
      dispatch({ type: "LOAD_CONTACTLISTS", payload: data.records });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    const companyId = user.companyId;
    const onContactListEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTLIST", payload: data.record });
      }
      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACTLIST", payload: +data.id });
      }
    };
    socket.on(`company-${companyId}-ContactList`, onContactListEvent);
    return () => {
      socket.off(`company-${companyId}-ContactList`, onContactListEvent);
    };
  }, []);

  const handleOpenContactListModal = () => {
    setSelectedContactList(null);
    setContactListModalOpen(true);
  };

  const handleCloseContactListModal = () => {
    setSelectedContactList(null);
    setContactListModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditContactList = (contactList) => {
    setSelectedContactList(contactList);
    setContactListModalOpen(true);
  };

  const handleDeleteContactList = async (contactListId) => {
    try {
      await api.delete(`/contact-lists/${contactListId}`);
      toast.success(i18n.t("contactLists.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContactList(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const goToContacts = (id) => {
    history.push(`/contact-lists/${id}/contacts`);
  };

  return (
    <MainContainer>
      <ConfirmationModal
        title={deletingContactList && `${i18n.t("contactLists.confirmationModal.deleteTitle")} ${deletingContactList.name}?`}
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDeleteContactList(deletingContactList.id)}
      >
        {i18n.t("contactLists.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      <ContactListDialog
        open={contactListModalOpen}
        onClose={handleCloseContactListModal}
        contactListId={selectedContactList && selectedContactList.id}
      />
      <div className={classes.headerContainer}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="h5" className={classes.title}>
              {i18n.t("contactLists.title")}
            </Typography>
            <Typography variant="body1" style={{ opacity: 0.8 }}>
              Gerencie suas listas de contatos e facilite seus disparos.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item xs={12} sm={7}>
                <Paper className={classes.searchPaper} elevation={0}>
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "rgba(255,255,255,0.7)" }} />
                  </InputAdornment>
                  <TextField
                    fullWidth
                    placeholder={i18n.t("contacts.searchPlaceholder")}
                    type="search"
                    value={searchParam}
                    onChange={handleSearch}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                </Paper>
              </Grid>
              <Grid item xs={12} sm={5}>
                <Button
                  fullWidth
                  variant="contained"
                  startIcon={<AddIcon />}
                  className={classes.addButton}
                  onClick={handleOpenContactListModal}
                >
                  {i18n.t("contactLists.buttons.add")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Paper
        className={classes.mainPaper}
        variant="outlined"
        onScroll={handleScroll}
      >
        <Grid container spacing={4}>
          {loading ? (
            <Grid item xs={12}>
              <Typography align="center">Carregando...</Typography>
            </Grid>
          ) : (
            contactLists.map((contactList) => (
              <Grid item xs={12} sm={6} md={4} key={contactList.id}>
                <Card className={classes.listCard} elevation={0}>
                  <CardContent className={classes.cardContent}>
                    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                      <Typography variant="h6" style={{ fontWeight: 700 }}>
                        {contactList.name}
                      </Typography>
                      <Chip
                        label={`${contactList.contactsCount || 0} contatos`}
                        className={classes.countChip}
                        size="small"
                      />
                    </Box>

                    <Box mt={2} mb={2} display="flex" alignItems="center" gap="10px">
                      <ListAltIcon color="action" fontSize="small" />
                      <Typography variant="body2" color="textSecondary">
                        ID: {contactList.id}
                      </Typography>
                    </Box>

                    <Divider className={classes.divider} />

                    <Box display="flex" justifyContent="space-around">
                      <a href={planilhaExemplo} download="planilha.xlsx" style={{ textDecoration: "none" }}>
                        <IconButton
                          size="small"
                          className={`${classes.iconButton} ${classes.downloadBtn}`}
                          title="Baixar Modelo"
                        >
                          <DownloadIcon />
                        </IconButton>
                      </a>
                      <IconButton
                        size="small"
                        onClick={() => goToContacts(contactList.id)}
                        className={`${classes.iconButton} ${classes.viewBtn}`}
                        title="Ver Contatos"
                      >
                        <PeopleIcon />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => handleEditContactList(contactList)}
                        className={`${classes.iconButton} ${classes.editBtn}`}
                        title="Editar"
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setConfirmModalOpen(true);
                          setDeletingContactList(contactList);
                        }}
                        className={`${classes.iconButton} ${classes.deleteBtn}`}
                        title="Excluir"
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))
          )}
        </Grid>
      </Paper>
    </MainContainer>
  );
};

export default ContactLists;
